<template>
  <div style="padding:20px 50px">
    <lay-page-header :content="name + ' 实时数据折线图, 当前数据条数：' + monitorData.length + '条 最近更新时间：' + (monitorData.slice(-1)?.[0]?.now ?? '------')" @back="back"></lay-page-header>
    <lay-col md="24">
      <div >
        <lay-card>
          <template v-slot:body>
            <lay-row space="10">
              <lay-col md="24">
                <div style="padding: 10px;">
                  <lay-table :columns="columns" :data-source="filterDataSource" height="91px">
                    <template #cabinet_name="{ row }">
                      <span>【{{row.cabinet_no}}】{{row.cabinet_name}}</span>
                    </template>
                    <template #di="{ row }">
                      <span>{{row.status == 1 ? (row.di == 0 ? '分位' : '合位') : '--'}}</span>
                    </template>
                    <template #temperature="{ row }">
                      <span>{{row.status == 1 ? row.i + '℃' : '--'}}</span>
                    </template>
                    <template #humidity="{ row }">
                      <span>{{row.status == 1 ? row.u + '%RH' : '--'}}</span>
                    </template>
                    <template #operation>
                      <lay-button size="xs"  suffix-icon="layui-icon-time" @click="toViewHistory">历史记录</lay-button>
                    </template>
                  </lay-table>
                </div>
              </lay-col>
              <lay-col md="24" v-if="type == 0">
                <div  style="text-align: center;line-height: 20px;color: #363636">
                  说明：<span>ia：A相电流</span>&nbsp;
                  <span>ib：B相电流</span>&nbsp;
                  <span>ic：C相电流</span>&nbsp;
                  <span>i：平均相电流</span>&nbsp;
                  <span>u：平均相电压</span>&nbsp;
                  <span>ux：平均线电压</span>&nbsp;
                  <span>p：有功功率</span>&nbsp;
                  <span>q：无功功率</span>&nbsp;
                  <span>pf：功率因数</span>
                </div>
              </lay-col>
            </lay-row>
            <v-chart ref="vchart" class="chart" :option="option"></v-chart>
          </template>
        </lay-card>
      </div>
    </lay-col>
    <lay-layer v-model="viewHistory" :shade="true" :shade-close="false" :area="['1000px', '600px']" title="历史记录" :move="true">
      <lay-row>
        <lay-col md="12">
          <lay-field title="日期选择" style="margin: 35px 10px;width:400px;" >
            <lay-date-picker  v-model="historyDate"   static allow-clear simple>
              <template #default="{ type, dayjs }">
                <div v-if="type === 'date'" class="date-cell">
                  {{ `${dayjs.format('D')}` }}
                  <lay-icon :type="isSpecial(dayjs.format('YYYY-MM-DD')) ? 'layui-icon-star' : 'layui-icon-time'" color="#FF5722" v-if='enabledDate.join("").indexOf(dayjs.format("YYYY-MM-DD")) != -1'></lay-icon>
                </div>
                <template v-if="type === 'month'">
                  {{ `${dayjs.month() + 1}月` }}
                </template>
                <template v-if="type === 'year'">
                  {{ `${dayjs.year()}年` }}
                </template>
              </template>
            </lay-date-picker>
          </lay-field>
        </lay-col>
        <lay-col md="12">
          <div style="line-height: 30px">
            <lay-field title="信息摘要（近一年）" style="margin: 35px 10px;width:400px;" >
              <p>记录开始时间：{{dumps[0]?.from}}</p>
              <p>记录结束时间：{{dumps[dumps.length - 1]?.to}}</p>
              <p>记录总天数：{{dumps.length}}天</p>
            </lay-field>
            <lay-field title="信息摘要（当前选择）" style="margin: 35px 10px;width:400px;" >
              <p>当前选择日期：{{historyDate ?? '未选择'}}  <lay-button v-if="isSpecial(historyDate)"  size="xs" border-style="dashed">比赛日</lay-button></p>
              <template v-if="currentSelected != -1">
                <p>记录开始时间：{{dumps[currentSelected]?.from}}</p>
                <p>记录结束时间：{{dumps[currentSelected]?.to}}</p>
                <p>数据总条数：{{dumps[currentSelected].len}}</p>
                <p>数据大小(B)：{{dumps[currentSelected].size}}</p>
                <lay-button size="xs" fluid  suffix-icon="layui-icon-time" @click="viewHistoryChart = true">生成当前选择历史记录折线图</lay-button>
              </template>
            </lay-field>
          </div>
        </lay-col>
      </lay-row>

    </lay-layer>
    <lay-layer v-model="viewHistoryChart" :shade="true"  :title="name + '的历史记录'" :move="true" :area="['90%', 'auto']">
        <RealtimeDataHistoryView :location="location" :id="dumps[currentSelected].id" :now="historyDate" :type="type" :name="name"/>
    </lay-layer>
  </div>
</template>

<script setup>
import {computed, ref, watch} from "vue";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart} from "echarts/charts";
import {TitleComponent, TooltipComponent, LegendComponent, GridComponent, DataZoomComponent,ToolboxComponent,MarkPointComponent} from "echarts/components";
import VChart from "vue-echarts";
import {useRealTimeDataService} from "@/assets/js/realTimeDataService";
import {useRoute, useRouter} from "vue-router/dist/vue-router";
import axios from "axios";
import {layer} from "@layui/layui-vue";
import RealtimeDataHistoryView from "@/components/utils/RealtimeDataHistoryView";

use([CanvasRenderer, LineChart, TitleComponent, TooltipComponent, LegendComponent, GridComponent, DataZoomComponent, ToolboxComponent, MarkPointComponent]);
const vchart = ref()
// const dataSource = ref([]);
const monitorData = ref([])
const route = useRoute()
const name = route.query.name;
const location = route.query.location;
const type = route.query.type;
let pageNum = 0, pageSize = 150;
const loading = ref(false);
const historyDate = ref()
const viewHistory = ref(false)
const viewHistoryChart = ref(false)
// const node = ref([])
const enabledDate = ref([])
const dumps = ref([])
const currentSelected = ref(-1);
const special = ['2026-03-20', '2026-04-04', '2026-04-17', '2026-04-26', '2026-05-02', '2026-05-10', '2026-05-24', '2026-06-26', '2026-07-05', '2026-07-25', '2026-08-08', '2026-08-29', '2026-10-10', '2026-10-17', '2026-11-08']

function isSpecial(date){
  for (let s of special){
    if (s == date) return true;
  }
  return false;
}

function toViewHistory(){
  realTimeDataCacheForDumpInfos();
}

watch(historyDate, () => {
  currentSelected.value = -1;
   for (let i = 0 ; i < dumps.value.length ; i++){
     if (dumps.value[i].from.indexOf(historyDate.value) != -1 || dumps.value[i].to.indexOf(historyDate.value) != -1){
        currentSelected.value = i;
        break;
     }
   }
})



function realTimeDataCacheForDumpInfos(){
  let id = filterDataSource.value[0]?.id;
  if (!id) return;
  enabledDate.value.length = 0;
  axios.get(`/realtime/data/dump_infos?node_id=${id}`)
      .then(function (response) {
        if (response.data.code == 0){
          dumps.value = response.data.data;
          if (dumps.value?.length){
            for (let dump of dumps.value){
              enabledDate.value.push(dump.from);
              enabledDate.value.push(dump.to);
            }
          }
          else {
            dumps.value = []
          }
        }
      })
      .catch(function () {
        console.log("网络请求失败，请稍后重试")
        layer.closeAll()
      })
      .finally(function () {
        viewHistory.value = true;
      });
}

function realTimeDataCacheForOneWeek(){
  axios.get(`/realtime/data/cached_for_one_week?location=${location}&pageNum=${pageNum++}&pageSize=${pageSize}`)
      .then(function (response) {
        if (response.data.code == 0){
          monitorData.value.push(...(response.data.data['list']));
          if (response.data.data['isLastPage'] == false){
            setTimeout(() => {
              realTimeDataCacheForOneWeek();
            }, 200)
          }
          else {
            loading.value = true;
            renewChart()
            layer.closeAll()
          }
        }
      })
      .catch(function () {
        console.log("网络请求失败，请稍后重试")
        layer.closeAll()
      })
      .finally(function () {

      });
}




function service(data){
  if (!loading.value) return;
  // if (node.value.length == 0){
  //   for (let d of data){
  //     node.value.push(d);
  //   }
  // }
  // let dsLen = dataSource.value.length;
  // if (dsLen < data.length){
  //   dataSource.value = data;
  // }
  // else {
  //   for (let i = 0 ; i < dsLen ; i++){
  //     let node = dataSource.value[i];
  //     for (let updateNode of data){
  //       if (node.location == updateNode.location){
  //         dataSource.value[i] = updateNode;
  //         break;
  //       }
  //     }
  //   }
  // }

  if (vchart.value){
    let D1_1AN1 = null;
    console.log(data)
    console.log("renew")
    for (let d of data){
      if (d.location == location){
        D1_1AN1 = d;
      }
    }
    if (!D1_1AN1 || D1_1AN1.status == 0) return;
    let len = monitorData.value.length
    if (len > 0){
      if (D1_1AN1['now'] == monitorData.value[len - 1]['now']){
        return;
      }
    }
    monitorData.value.push(D1_1AN1);
    if (monitorData.value.length > 8640){
      monitorData.value.pop();
    }
    renewChart()
  }
}

function renewChart(){
  let innerOption = vchart.value.getOption();
  let configs = series_configs();
  for (let i = 0 ; i < configs.length ; i++){
    innerOption.series[i].data = configs[i].data;
  }
  innerOption.xAxis[0].data = (() => {
    let _data = []
    for (let d of monitorData.value){
      _data.push(d['now'])
    }
    return _data;
  })()
  vchart.value.setOption(innerOption, true)
}


useRealTimeDataService(service, null, {checkFR: false, dataType: 1, nodeTypes: -1, location});

realTimeDataCacheForOneWeek()
layer.load(0, { time: 9999999999})


const realtime_series_config = (name, color, data, fieldName = undefined) => {
  return {
    name: name,
    type: 'line',
    symbol: 'none',
    sampling: 'lttb',
    itemStyle: {
      color: color
    },
    markPoint: {
      data: [
        {type: 'max', name: '最大值'},
        {type: 'min', name: '最小值',symbolRotate: '180',label: {offset: [0, 10]}}
      ]
    },
    data: (() => {
      let _data = []
      for (let d of data){
        _data.push(d[fieldName ?? name])
      }
      return _data;
    })()
  }
}

const option = (() => {
  if (type == 0){
    return {
      title: {
        text: "",
            left: "left"
      },
      tooltip: {
        trigger: 'axis',
            position: function (pt) {
          return [pt[0], '10%'];
        }
      },
      legend: {
        data: ['ia','ib', 'ic', "i", 'u', 'ux', "p", "q", "pf", "开关量"],
            selected: {
          "ia": false,
              "ib": false,
              "ic": false,
              "i": true,
              "u": false,
              "ux": false,
              "p": false,
              "q": false,
              "pf":false,
              "开关量":false
        }
      },
      xAxis: {
        type: 'category',
            boundaryGap: false,
            data: []
      },
      yAxis: {
        type: 'value',
            boundaryGap: [0, '100%']
      },
      toolbox: {
        feature: {
          // dataZoom: {
          //   yAxisIndex: 'none'
          // },
          // restore: {},
          saveAsImage: {
            name
          }
        }
      },
      dataZoom: [{
        type: 'inside',
        start: 0,
        end: 100
      }, {
        start: 0,
        end: 10
      }],
          series: series_configs()
    };
  }
  else if (type == 11){
    return {
      title: {
        text: "",
        left: "left"
      },
      tooltip: {
        trigger: 'axis',
        position: function (pt) {
          return [pt[0], '10%'];
        }
      },
      legend: {
        data: ['湿度',"温度"],
        selected: {
          "湿度": true,
          "温度": true,
        },
        formatter:(name) => {
          if (name == '湿度') return name + " %RH";
          if (name == '温度') return name + " ℃";
          return name;
        }
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: []
      },
      yAxis: {
        type: 'value',
        boundaryGap: [0, '100%']
      },
      toolbox: {
        feature: {
          // dataZoom: {
          //   yAxisIndex: 'none'
          // },
          // restore: {},
          saveAsImage: {
            name
          }
        }
      },
      dataZoom: [{
        type: 'inside',
        start: 0,
        end: 100
      }, {
        start: 0,
        end: 10
      }],
      series: series_configs()
    };
  }
})();

function series_configs(){
  if (type == 0){
    return [
      realtime_series_config('ia', '#27408b', monitorData.value),
      realtime_series_config('ib', '#ec4cff', monitorData.value),
      realtime_series_config('ic', '#b0493b', monitorData.value),
      realtime_series_config('i', '#EE9A00', monitorData.value),
      realtime_series_config('u', '#00b050', monitorData.value),
      realtime_series_config('ux', '#ff0000', monitorData.value),
      realtime_series_config('p', '#EE9A00', monitorData.value),
      realtime_series_config('q', '#00b050', monitorData.value),
      realtime_series_config('pf', '#ff0000', monitorData.value),
      realtime_series_config('开关量', '#ff0000', monitorData.value, "di"),
    ]
  }
  else if (type == 11){
    return [
      realtime_series_config('湿度', '#00b050', monitorData.value, 'u'),
      realtime_series_config('温度', '#EE9A00', monitorData.value, 'i'),
    ]
  }
}

let router = useRouter()
function back(){
  router.back()
}

const columns = (() => {
  if (type == 0){
    return [
      // {
      //   title:"名称",
      //   width:"150px",
      //   key:"cabinet_name",
      //   ellipsisTooltip: true,
      //   customSlot: "cabinet_name",
      // },
      {
        title:"CT",
        width:"50px",
        key:"ct",
      },
      {
        title:"开关量",
        width:"50px",
        key:"di",
        customSlot: "di",
      },
      {
        title:"A相电流",
        width:"50px",
        key:"ia",
        ellipsisTooltip: true,
      },
      {
        title:"B相电流",
        width:"50px",
        key:"ib",
        ellipsisTooltip: true,
      },
      {
        title:"C相电流",
        width:"50px",
        key:"ic",
        ellipsisTooltip: true,
      },
      {
        title:"平均相电流",
        width:"50px",
        key:"i",
        ellipsisTooltip: true,
      },
      // {
      //   title:"A相电压",
      //   width:"50px",
      //   key:"ua",
      //   ellipsisTooltip: true,
      // },
      // {
      //   title:"B相电压",
      //   width:"50px",
      //   key:"ua",
      //   ellipsisTooltip: true,
      // },
      // {
      //   title:"C相电压",
      //   width:"50px",
      //   key:"ua",
      //   ellipsisTooltip: true,
      // },
      {
        title:"平均相电压",
        width:"50px",
        key:"u",
        ellipsisTooltip: true,
      },
      {
        title:"平均线电压",
        width:"50px",
        key:"ux",
        ellipsisTooltip: true,
      },
      {
        title:"有功功率",
        width:"50px",
        key:"p",
        ellipsisTooltip: true,

      },
      {
        title:"无功功率",
        width:"50px",
        key:"q",
        ellipsisTooltip: true,
      },
      {
        title:"功率因数",
        width:"50px",
        key:"pf",
        ellipsisTooltip: true,
      },
      {
        title:"有功电能",
        width:"80px",
        key:"w",
        ellipsisTooltip: true,
      },
      {
        title:"更新时间",
        width:"100px",
        key:"now",
        ellipsisTooltip: true,
      },
      {
        title:"查看",
        width:"50px",
        customSlot: "operation",
      },
    ]
  }
  else if (type == 11){
    return [
      // {
      //   title:"名称",
      //   width:"150px",
      //   key:"cabinet_name",
      //   ellipsisTooltip: true,
      //   customSlot: "cabinet_name",
      // },
      {
        title:"湿度",
        width:"100px",
        key:"u",
        ellipsisTooltip: true,
        customSlot: "humidity",
      },
      {
        title:"温度",
        width:"100px",
        key:"i",
        ellipsisTooltip: true,
        customSlot: "temperature",
      },
      {
        title:"更新时间",
        width:"100px",
        key:"now",
        ellipsisTooltip: true,
      },
      {
        title:"查看",
        width:"50px",
        customSlot: "operation",
      },
    ]
  }
})();

const filterDataSource = computed(() => {
  return monitorData.value.length > 0 ? monitorData.value.slice(-1) : [{}]
})


</script>

<style >
.chart{
  height: 650px;
  padding-top: 20px;
}
.download{
  font-size: 23px;cursor: pointer;
}
.refresh{
  font-size: 18px;cursor: pointer;
}
.layui-date-picker-static .layui-laydate-main-date{
  width: auto;
}
.date-cell {
  width: 44px;
  height: 40px;
  display: flex;
  flex-direction: column;
}
</style>